import { Colors, Router, Storage } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';

//Api
import { createProfile } from '../../../api/profiles';

//Components
import AuthRoute from '../../../components/layouts/AuthRoute/AuthRoute';
import ProfileName from './components/ProfileName';
import ChooseAvatar from './components/ChooseAvatar';
import Language from './components/Language';
import AutoPlay from './components/Autoplay';
import Button from './components/Button';
import Keyboard from '../../../components/Keyboard/components/Keyboard';
import { keyboardConfig } from './components/keyboardConfig';

let profileInfo;

export default class CreateProfile extends AuthRoute {
  static _template() {
    return {
      Title: {
        y: 195,
        x: 317,
        text: {
          text: 'Create Profile',
          fontFace: 'OpenSans-SemiBold',
          fontSize: 60,
          textColor: Colors('#fafafa').get(),
        },
      },

      ProfileName: {
        collision: true,
        type: ProfileName,
      },

      Keyboard: {
        type: Keyboard,
        y: 800,
        w: 1920,
        rect: true,
        color: Colors('#000000').alpha(0).get(),
        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
        visible: false,
        limit: 20,
      },

      ChooseAvatar: {
        collision: true,
        type: ChooseAvatar,
      },

      Language: {
        collision: true,
        type: Language,
      },

      Autoplay: {
        collision: true,
        type: AutoPlay,
      },

      Picture: {
        type: Column,
      },

      Button: {
        collision: true,
        type: Button,
      },
    };
  }

  _enable() {
    this.tag('Keyboard').visible = false;
    this._setState('ProfileName');
  }

  _handleBack() {
    if (this.tag('Keyboard').visible) {
      this.tag('Keyboard').visible = false;
      this._setState('ProfileName');
    } else {
      Router.back();
    }
  }

  onInputChanged({ input }) {
    this._input = input;
  }

  _changePlaceholder() {
    this.tag('ProfileName')._changePlaceholder();
  }

  $addInputListen() {
    this._InputField.tag('Input').listening = true;
  }

  $removeInputListe() {
    this._InputField.tag('Input').listening = false;
  }

  get _ChooseAvatar() {
    return this.tag('ChooseAvatar');
  }

  get _Title() {
    return this.tag('Title');
  }

  get _Autoplay() {
    return this.tag('Autoplay');
  }

  get _Language() {
    return this.tag('Language');
  }
  get _InputField() {
    return this.tag('ProfileName.InputWrapper');
  }

  get _ProfileName() {
    return this.tag('ProfileName');
  }

  get _Keyboard() {
    return this.tag('Keyboard');
  }

  get _Picture() {
    return this.tag('Picture');
  }

  $setState(state) {
    this._setState(state);
  }

  static _states() {
    return [
      class ProfileName extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('ProfileName');
        }
        _handleEnter() {
          this._Keyboard.visible = true;
          this._setState('Keyboard');
          this.$addInputListen();
        }

        _handleClick() {
          this._handleEnter();
        }

        _handleRight() {
          return this._setState('Button');
        }

        _handleDown() {
          this._setState('ChooseAvatar');
        }
      },
      class Keyboard extends this {
        _getFocused() {
          this.$addInputListen();
          return this._Keyboard;
        }
        _handleUp() {
          this._setState('ProfileName');
          this._Keyboard.visible = false;
          this.$removeInputListe();
        }

        _handleRight() {
          return;
        }
      },
      class ChooseAvatar extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('ChooseAvatar');
        }
        _handleClick() {
          this._handleEnter();
        }
        _handleEnter() {
          Router.navigate('profile/choose-avatar', { profileId: 'create-profile' });
        }
        _handleRight() {
          return this._setState('Button');
        }
        _handleUp() {
          return this._setState('ProfileName');
        }
        _handleDown() {
          return this._setState('Language');
        }
      },
      class Language extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('Language');
        }
        _handleRight() {
          return this._setState('Button');
        }
        _handleUp() {
          return this._setState('ChooseAvatar');
        }
        _handleDown() {
          return this._setState('Autoplay');
        }
      },
      class Autoplay extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('Autoplay');
        }
        _handleRight() {
          return this._setState('Button');
        }
        _handleUp() {
          return this._setState('Language');
        }
      },
      class Button extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('Button');
        }
        _createProfile() {
          profileInfo = Storage.get('create-profile');
          let profile = {
            avatar_id: profileInfo.avatar_id,
            first_name: this.tag('ProfileName.Input').value,
            native_language: this.tag('Language.CurrentValue').lng,
            autoplay: false,
          };
          createProfile(profile)
            .then((response) => {
              Router.navigate('profile');
            })
            .catch((error) => {
              console.error('Failed to update profile', error);
            });
        }
        _captureEnter() {
          if (this._ProfileName.tag('Input').value.length > 0) {
            this._createProfile();
            this._ProfileName.tag('Input').value = '';
            this._changePlaceholder();
          }
        }

        _handleClick() {
          this._captureEnter();
        }

        _handleDown() {
          if (this._Keyboard.visible) {
            this._setState('Keyboard');
          }
        }
        _handleLeft() {
          this._setState('ProfileName');
        }
      },
    ];
  }
}
